import React from 'react'
import cs from 'classnames'
import { useRouter } from 'next/router'
import { getLibraryURL } from '../../../graphql/learning'
import { useSeriesCourseText } from '../../../utils/series-course-text'

const ChevronRight = ({}) => {
  return (
    <svg
      width={17}
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.4211 8L19 15.285L43.1053 39L19 62.715L26.4211 70L58 39L26.4211 8Z"
        fill="rgba(0,0,0,0.3)"
      />
    </svg>
  )
}

const Breadcrumbs = (): React.ReactElement => {
  const { Course } = useSeriesCourseText()
  const router = useRouter()
  const isViewingSeriesList = !router.pathname.includes('[seriesID]')

  const onClick = isViewingSeriesList
    ? null
    : () => {
        router.push(getLibraryURL({ id: router.query.id }))
      }

  return (
    <div className={'learning__breadcrumbs'}>
      <a
        style={{ textDecoration: isViewingSeriesList ? 'none' : 'underline' }}
        onClick={onClick}
      >
        <div
          className={cs('learning__breadcrumb', {
            'learning__breadcrumb--active': isViewingSeriesList,
            'learning__breadcrumb--cursor-pointer': !isViewingSeriesList,
          })}
        >
          Library
        </div>
      </a>
      <ChevronRight />
      <div
        className={cs('learning__breadcrumb', {
          'learning__breadcrumb--active': !isViewingSeriesList,
        })}
      >
        {Course}
      </div>
    </div>
  )
}

export default Breadcrumbs
